"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CollectionHighlight = _interopRequireDefault(require("../collection_highlight/views/CollectionHighlight"));

var _SlantedCollectionHightlight = _interopRequireDefault(require("../collection_highlight_slanted/SlantedCollectionHightlight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _window = window,
    featureManager = _window.featureManager;

var CollectionHighlightViewFactory =
/*#__PURE__*/
function () {
  function CollectionHighlightViewFactory() {
    _classCallCheck(this, CollectionHighlightViewFactory);
  }

  _createClass(CollectionHighlightViewFactory, null, [{
    key: "Build",
    value: function Build(collectionDefinition, viewOptions) {
      var forceSlanted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (featureManager.isEnabled('LuckyDay') && collectionDefinition.isLuckyDay || forceSlanted) {
        return new _SlantedCollectionHightlight["default"](viewOptions);
      } else {
        return new _CollectionHighlight["default"](viewOptions);
      }
    }
  }]);

  return CollectionHighlightViewFactory;
}();

exports["default"] = CollectionHighlightViewFactory;